module.exports = __webpack_public_path__ + "static/media/DSC09999.38db9147.jpg";